export default "__VITE_ASSET__DSBrsIIm__"